import { Link } from 'react-router-dom'
import { MapPinned, ChevronRight } from 'lucide-react'
import { PRODUCTS } from './registry'
import { ProductTile } from './ProductTile'
import { hasR2 } from '@/config'
import './products.css'

export function ProductsView() {
  return (
    <div className="products">
      <header className="view-head">
        <h1 className="view-title">Products</h1>
        <p className="view-sub">Triple-A’s rendered guidance, live off the R2 feeds.</p>
      </header>

      <Link to="/map" className="products__mapcard">
        <span className="products__mapcard-icon">
          <MapPinned size={22} />
        </span>
        <span className="products__mapcard-text">
          <strong>Weather Map</strong>
          <span>Interactive radar · inspect &amp; measure</span>
        </span>
        <ChevronRight size={20} className="products__mapcard-chev" />
      </Link>

      {!hasR2 && (
        <p className="products__note">
          Showing product entry points. Set <code>VITE_R2_BASE_URL</code> to light up live imagery.
        </p>
      )}

      <div className="products__grid">
        {PRODUCTS.map((p) => (
          <ProductTile key={p.id} product={p} />
        ))}
      </div>
    </div>
  )
}
